import {  Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { URLS } from '../../core/services/apiurls.constants';
import { AuthLoginService } from 'src/app/auth/auth-login.service';


@Injectable({ providedIn: 'root' })
export class CommonService {
 
  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  };



  constructor(private http: HttpClient, private loginservice: AuthLoginService) { }
 
  private message = new BehaviorSubject('');
  public cco_med = new BehaviorSubject<any>(null);
  private document = new BehaviorSubject<any>('');
  private letterID = new BehaviorSubject('');
  private picChange = new BehaviorSubject('');
  private ccolifePlan = new BehaviorSubject('');
  private temp = new BehaviorSubject('');
  private email = new BehaviorSubject('');
  private pw = new BehaviorSubject('');
  public openform = new BehaviorSubject<any>('');
  public validateform = new BehaviorSubject<any>('');
  public formId = new BehaviorSubject<any>('');
  public isCCO = new BehaviorSubject<any>('');
  public loggout = new BehaviorSubject<any>('');
  public PDStatus = new BehaviorSubject<any>('');
  public consentUpdate = new BehaviorSubject<any>('');
  public mailmergesign = new BehaviorSubject<any>('');
  public uD_IAP_MSDPID_ = new BehaviorSubject<any>('');
  // public packetRecordUpdate = new BehaviorSubject<any>(null);
  public fcbdD_LevelOfCareFreedomOfChoiceSoloID_ = new BehaviorSubject<any>('');

  statuspacket = this.PDStatus.asObservable();
  UploadDoc = this.document.asObservable();
  sharedList = this.message.asObservable();

 
  TempId = this.formId.asObservable();
  profile = this.document.asObservable();
  cco = this.ccolifePlan.asObservable();
  value = this.temp.asObservable();
  mail = this.email.asObservable();
  password = this.pw.asObservable();
  validateforms = this.validateform.asObservable();
  openforms = this.openform.asObservable();
  isCCOEnabled = this.isCCO.asObservable();
  loggOut = this.loggout.asObservable();
  consent = this.consentUpdate.asObservable();
  mailsign = this.mailmergesign.asObservable();
  uD_IAP_MSDPID_ID= this.uD_IAP_MSDPID_.asObservable();
    fcbdD_LevelOfCareFreedomOfChoiceSoloID_ID = this.fcbdD_LevelOfCareFreedomOfChoiceSoloID_.asObservable()

  // recordPacketUpdate = this.packetRecordUpdate.asObservable();

  private buttonClickSubject = new Subject<void>();
  buttonClick$ = this.buttonClickSubject.asObservable();

  triggerButtonClick(): void {
    this.buttonClickSubject.next();
  }
  private countSubject = new BehaviorSubject<any>([]); 
  count$ = this.countSubject.asObservable(); 

  updateCount(count: any) {
    this.countSubject.next(count); 
  }
  setLogoutType(type: string): void {
    this.loggout.next(type);
  }

  token() {
    return this.loginservice.getToken();
  }


  mailmergesignpreview(sign:any){
    this.mailmergesign.next(sign);
  }
 uD_IAP_MSDPID(sign:any){
    this.uD_IAP_MSDPID_.next(sign);
  }
  fcbdD_LevelOfCareFreedomOfChoiceSoloID(id:any){
this.fcbdD_LevelOfCareFreedomOfChoiceSoloID_.next(id)
  }
  //  packetsRecordUpdate(sign:any){
  //   this.packetRecordUpdate.next(sign);
  // }
  

  nextList(message: any) {
    this.message.next(message);
  }
  medList(medicationlist:any){
   this.cco_med.next(medicationlist);
  }
  
 
  fromLogout(logoutValue: any) {
    this.loggout.next(logoutValue)
  }

  emailAddress(email: any) {
    this.email.next(email);
  }

  pWord(pw: any) {
    this.pw.next(pw);
  }

  sharedValue(temp: any) {
    this.temp.next(temp);
  }

  packetforms(open: any) {
    this.openform.next(open);
  }

  consentForm(form : any){
    this.consentUpdate.next(form);
  }

  packetdetailsstatus(status: any) {
    this.PDStatus.next(status);
  }

  CCOEnabled(isCCO: any) {
    this.isCCO.next(isCCO);
  }

  validatepacketforms(validate: any) {
    this.validateform.next(validate);
  }

  clearMemory() {
    this.document.next(null);
  }

  clearvalue() {
    this.openform.next(null);
  }

  letterTemp(letterID: any) {
    this.formId.next(letterID);
  }
  ccoPlan(letterID: any) {
    this.ccolifePlan.next(letterID);
  }
  profilePic(picChange: any) {
    this.message.next(picChange);
  }

  docUpload(document: any) {
    this.document.next(document);
  }


  // private packetData: any;

  // setPacketData(data: any) {
  //   this.packetData = data;
  // }

  // getPacketData() {
  //   return this.packetData;
  // }

  TimeZone() {
    let offset = new Date().getTimezoneOffset();
    return offset;
  }

   detectPersonNames(texts: string[]) {
    return this.http.post<string[]>(URLS.GOBAL_URL + URLS.Translate.DetectPersonName, { texts });
  }

  BillPay(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.createpayment, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  WaysterPay(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.wayster_insert, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  MFAAuth(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.MFA, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetProfile(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.profile, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  SwitchClient(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.switchclient, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  //print
  print(clientId: any, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.print + clientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }



  GetPacketForms(token: any, clientid: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.AvaliableForms + clientid + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  UpdatePacketStatus(status: string, fDetailID: any, formid: any, action: any, packetDetailId: any, token: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.UpdateStatus + status + '&FormDetailID=' + fDetailID + '&FormID=' + formid + '&Action=' + action + '&PacketDetailID=' + packetDetailId + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetDashboardCounts(ClientId: number, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getDashboardCounts + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetTodos(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.gettodos + ClientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetAppointments(ClientId: number, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getAppointments + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  ChangePassword(editedValue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.changepassword, editedValue, this.httpOptions).pipe(
      map((res) => {
        // return res as any;
        return res;
      })
    )
  }

  CheckCompanyCode(email: any, CompanyCode: any, action: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.checkcompanycode + '?Email=' + email + '&CompanyCode=' + CompanyCode + '&Action=' + action, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CheckEmail(Email: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.checkemail + Email + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CreateProfile(createuser: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.createProfile, createuser, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

 countybordform(payload: any) {
        return this.http.post(URLS.GOBAL_URL + URLS.Profile.createFCBDDApplication, payload, this.httpOptions).pipe(
          map((res) => res)
        );
      }

 fcbddCountyBoardForm(payload: any) {
        return this.http.post(URLS.GOBAL_URL + URLS.Profile.createFcbddCountyBoardApplication, payload, this.httpOptions).pipe(
          map((res) => res)
        );
      }

  insertProfilePic(saveDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.insertClientProfile, saveDetails, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  refreshToken(token: string) {
    sessionStorage.setItem('access_token', JSON.stringify(token));
  }


  AppointmentsList(ClientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getappointments + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  NewSecureMessage(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.insertsecuremessage, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  AuditNewSecureMessage(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.auditsecuremessageinsert, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  SecureMessage(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.securemessage + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  secureMessageDocument(documentId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.secureMessageDocument + documentId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  UpdateSentMessage(editmsg: any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.updatesentmessage, editmsg, this.httpOptions
      ).pipe(
        map((res) => {
          return res;
        })
      );
  }

  updateSecureMessageread(messageId: number, isread: boolean) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.updateSecureMessagesread + messageId + '&isread=' + isread + '&SchemaName=' + this.token(),
        this.httpOptions
      )  .pipe(map((res) => {
          return res;
        })
      );
  }

  ReplySecureMessage(clientId: number, type: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.replysecuremessage + clientId + '&Type=' + type + '&SchemaName=' + this.token()
      , this.httpOptions)
      .pipe
      (map((res) => {
        return res;
      })
      );
  }
  DeleteSecureMessage(msgID: number){
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.deletesecuremessage + msgID + '&SchemaName=' + this.token()
    , this.httpOptions).pipe(map((res) => {
      return res
    }))
  }

  DeleteAuditSecureMessage(payload:any){
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.auditsecuremessagedelete,payload
    , this.httpOptions).pipe(map((res) => {
      return res
    }))
  }
  GetTaskDetails(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Task.taskdetails + clientId + '&SchemaName=' + this.token()
      , this.httpOptions).pipe(map((res) => {
        return res
      }))
  }
  UpdateTaskDetails(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Task.taskUpdatedetails, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  
  get getAdditionalHeaders(): string {
    const additionalHeaders = JSON.stringify({
      Offset: '',
      Timezone: '',
      IPAddress: '',
    });
    return additionalHeaders;
  }

  GetProblemList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getproblemList + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return err;
        })
      );
  }

  GetMedicationList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getmedicationList + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetMedicationScheduleList(clientId: number, medicationListId: number): Observable<any> {
    const url =
      URLS.GOBAL_URL +
      URLS.Health_Record.GetScheduleMedicationList +
      clientId +
      '&MedicationListID=' + medicationListId +  // Add MedicationListID to the URL
      '&SchemaName=' + this.token(); // Assuming token() returns the schema name
  
    return this.http.post(url, this.httpOptions).pipe(
      map((res: any) => {
        return res; // Return the API response
      })
    );
  }
  

  GetCCoAllergies(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ccoLifePlan.ccoAllergies + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetNonAllergyList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getnonallergylist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetAllergyList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getallergylist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetDocumentList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getdocumentlist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }


  getById(id: string) {

    return this.http.get(URLS.GOBAL_URL + URLS.Surveys.getClinicalSurveys + id);

  }

  GetClinicalSurveyList(clientId: number, surveyId: any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Surveys.getClinicalSurveys + clientId + '&UD_ClinicSatisfactionSurveyID=' + surveyId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetGad7(clientId: any, gadId: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getgad7 + clientId + '&GAD7ID=' + gadId + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  TemplateGad(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.gad7api.template_details + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetClinicalSurveyTemplateDetails(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Surveys.getSurveyTemplateDetails + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetLabResult(clientId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.Health_Record.getlabresults + clientId + '&SchemaName=' + this.token(),
      this.httpOptions
    )
      .pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetImmunization(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getimmunization + clientId + '&SchemaName=' + this.token()
      , this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetEncounterList(clientId: number, offset: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getencounters + clientId + '&offset=' + offset + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetSmokingList(clientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getsmokingstatus + clientId + '&offset=' + offset
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      })
      )
  }
  GetTreatmentPlan(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.gettreatment + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      }))
  }
  GetNursing(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getnursing + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      }))
  }
  GetDietOrder(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getdietorder + ClientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetVitalSign(ClientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getvitalsign + ClientId + '&offset=' + offset
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetDiagnosis(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getdiagnosis + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetContact(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getcontacts + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetHouseholdMembers(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getHouseholdMembers + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetLifePlan(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getlifePlan + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetProfileImage(clientId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.profileImage, clientId, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  GetMyTeam(clientid: any, type: string, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.MyTeam.myteam + clientid + '&Type=' + type
      + '&SchemaName=' + token, this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }

  DocType(Clientid: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.doctype + Clientid
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  UpDocList(Clientid: number, email: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.getupdoc + Clientid + '&portalUserID=' + email
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  UpdateDocList(editload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.updatedoc, editload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  NewUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.insertdoc, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  AuditNewDocUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.auditdocinsert, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  DeleteAuditDocList(payload:any){    
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.auditdocdelete , payload,this.httpOptions).pipe(
      map((res:any)=>{
        return res;
      })
    )
  }
  DeleteDocList(clientdocID:any){    
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.deletedoc + '?SchemaName=' + this.token(), clientdocID, this.httpOptions).pipe(
      map((res:any)=>{
        return res;
      })
    )
  }

  SaveNewMail(saveDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.savemail, saveDetails, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  saveNewSurvey(saveSurvey: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Surveys.saveNewSurvey, saveSurvey, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

  saveNewGad(savegad7: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.gad7api.insertgap7, savegad7, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

  EditMail(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.editmail, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  editSurvey(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Surveys.editSurveys, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  DeleteMail(letterId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.deletemail + letterId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  DeleteSurvey(surveyId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Surveys.deleteClinicalSurvey + surveyId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }
  GetSelectTemplates(CompanyID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.getmail + CompanyID + '&ClientID=' + this.loginservice.clientid()
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetMailTemplate(CompanyID: number, tempID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.gettemplate + CompanyID + '&ClientID=' + this.loginservice.clientid() + '&MailMergeTemplateID=' + tempID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

 
  GetMailID(ClientID: any, letterTemplateID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.maildetailID + ClientID + '&LetterTemplateID=' + letterTemplateID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetMailList(ClientID: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.maildetails + ClientID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }



  RequestApointment(ClientID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.requestAppointment + ClientID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }


  GetTimeZone(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.getTimeZone, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )

  }

  SaveAppointment(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.saveAppointment, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  
  AuditRequestAppointment(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.auditrequestAppointment, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  UnAvailTime(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.unavailtime, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CompanyLogo(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.companylogo, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  GetSecurityQA(credentials: any) {
    console.log("credentials=", credentials)
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getSecurityQA, credentials, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  ForgotPassword(newPassword: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.forgotpassword, newPassword, this.httpOptions).pipe(
      map((res) => {
        // return res as any;
        return res;
      })
    )
  }

  CreatePreAdmission(createprofile: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.createPreAdmission, createprofile, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  AddClient(addClients: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.addClient, addClients, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }


  DueAmount(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.dueAmount + ClientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;

      })
    )
  }

  GetSecurityQuestion(clientId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getSecurityQuestion, clientId, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getBroadcastMessage(companyCode: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.broadcastMessage + companyCode + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  ccologout(clientId: any, logoutDateTime: any, email: any,AuditId:any ) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.portalLogout + clientId + '&Email=' + email + '&LogoutDateTime=' + logoutDateTime + '&SchemaName=' + this.token() + '&AuditId='+AuditId, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

 

  logout(clientId: any, logoutDateTime: any, email: any ) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.portalLogout + clientId + '&Email=' + email + '&LogoutDateTime=' + logoutDateTime + '&SchemaName=' + this.token() , this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
 
  Statement(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.clientStatement, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  getPdfs(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getPdf + clientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetccoLifePlan(clientid: number, status: string, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.ccoLifePlan + clientid + '&Status=' + status
      + '&SchemaName=' + token, this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }

  GetccoContact(clientid: number, companyId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getContactDetail + clientid + '&CompanyId=' + companyId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }


  CCOPortalDocumentUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.GetCCOPortalDocumentUpload, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  NewCCODocumentUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.insertCCODocumentUpload, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  DeleteCCODocList(clienttrackingID: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.deleteCCODoc + '?SchemaName=' + this.token(), clienttrackingID, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }



  GetccoLifePlanUserType(clientId: number, email: any, lifePlanId: any, documentVid: any, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getccoUserType + clientId + '&Email=' + email + '&LifePlanID=' + lifePlanId + '&DocumentVersionID=' + documentVid + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  GetccoLifePlanPdf(lifePlanDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getccoLifePlanPdf, lifePlanDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  GetccoLifePlanApproval(approvalDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.ccoLifePlanApproval, approvalDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  AuditccoLifePlanApproval(approvalDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.auditccoLifePlanApproval, approvalDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }
  clientSignupData(base64Str: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.signUpData, base64Str, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  GetSigninPage(companyCode: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetUrl, companyCode, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetAuthUser(loginDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetUser, loginDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetAuthGenerateOtp(userDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetAuthOtp, userDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetUserClient(userDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getUserClient, userDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  updatePortalConsent(payloadDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.updatePolicy, payloadDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  verifyToken(token: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.VerifyToken, token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetPhqData(clientId: number, phqId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getPhq + clientId + '&PHQID=' + phqId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetPhqOPtions(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.PHQ9.getPhqOptions + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  NewPhq(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PHQ9.insertPhq, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  UpdatePhq(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PHQ9.updatePhq, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetCompletedPacket(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.GetPacketforms, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetSBHVital(clientId: any, SBHVitalID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getSolaceVital + clientId + '&UD_SolaceVitalSignsID=' + SBHVitalID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetAUDIT(clientId: any, auditID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getAudit + clientId + '&AuditID=' + auditID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetAims(clientId: any, aimsID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getAims + clientId + '&AimsID=' + aimsID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }

  GetAimsTd(clientId: any) {
    return this.http
      .get(URLS.GOBAL_URL + URLS.Health_Record.getAimsTd + clientId + '&schemaName=' + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  Getmadrs(clientId: any, madrsID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getMadrs + clientId + '&UD_MADRSID=' + madrsID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPtsd(clientId: any, ptsdID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getPtsd + clientId + '&UD_PTSDScreeningID=' + ptsdID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetBinge(clientId: any, BingeID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getBinge + clientId + '&UD_BINGEEATINGSCALEID=' + BingeID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetBocs(clientId: any, BcosID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getBocs + clientId + '&UD_YBOCSID=' + BcosID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }

  GetAuditOPtions(type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Audit.getAuditOptions + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  NewSBHVital(SBHVitals: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.SBHVitalapi.insertVital, SBHVitals, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewAudit(Audit: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Audit.insertAudit, Audit, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewAims(Aims: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Aims.InsertAimsAPI, Aims, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewMadrs(Madrs: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Madrs.InsertMadrsAPI, Madrs, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewPtsd(ptsd: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.ptsd.InsertPtsdAPI, ptsd, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )



  }
  NewBinge(binge: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.BingeScale.InsertBinge, binge, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }
  NewBocs(ybocs: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.ybocsScale.InsertBocs, ybocs, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }
  GetHamilton(clientId: any, hamID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.gethamilton + clientId + '&UD_HamiltonAnxietyScaleID=' + hamID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPrepProv(clientId: any, provID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getprepprov + clientId + '&UD_AppointmentPrepProviderID=' + provID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPrepTherapy(clientId: any, therapyID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getpreptherapy + clientId + '&UD_AppointmentPrepTherapyID=' + therapyID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetDisorderScale(clientId: any, provID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getDisorder + clientId + '&UD_MoodDisorderScaleID=' + provID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetSleepScale(clientId: any, SLeepID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getSleep + clientId + '&UD_EpworthSleepinessscaleID=' + SLeepID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  NewHmailton(hamilton: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.hemilton.InsertHamilton, hamilton, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  Newprovider(provider: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.prepProvider.InsertProvider, provider, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewTherapy(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.prepTherapy.InsertTherapy, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewDisorder(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.DisorderScale.InsertDisorder, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewSleepScale(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.SleepScale.InsertSleep, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }

  AuditLogData(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.auditlog, msgload, this.httpOptions).pipe(
      map((res : any) => {
        return res
      })
    )
  }

 GetCrossChildList(clientId: number, Action:string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getcrosschild + clientId + '&Action=' + Action + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res : any) => {
          return res;
        })
      );
  }

 GetCrossParentList(clientId: number, Action:string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getcrossparent + clientId + '&Action=' + Action + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res : any) => {
          return res;
        })
      );
  }

   GetCrossAdulttList(clientId: number, Action:string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getcrossadult + clientId + '&Action=' + Action + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res : any) => {
          return res;
        })
      );
  }

  GetAdultTBRiskAssessmentTemplateDetail(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.tbrisk.gettemplate + clientId + '&UD_AdultTBRiskAssessmentandScreeningFormID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

 GetTBRiskAssessment(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.tbrisk.gettbrisk + clientId + '&UD_AdultTBRiskAssessmentandScreeningFormID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   saveNewTBRisk(savetbrisk: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.tbrisk.addnewrisk, savetbrisk, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

  updateTBRisk(updateTBRisk: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.tbrisk.updateTBRisk, updateTBRisk, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

GetHivRiskAssessmentTemplateDetails(clientid: any,HepatitisRiskAssessmentToolID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getHIVTemplateDetails + clientid + '&UD_HepatitisRiskAssessmentToolID=' + HepatitisRiskAssessmentToolID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  

    GetHivRiskAssessment(clientid: any,HepatitisRiskAssessmentToolID: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getHIVDetails + clientid + '&UD_HepatitisRiskAssessmentToolID=' + HepatitisRiskAssessmentToolID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }


      InsertHivRiskAssessment(payload: any) {
         return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.insertHIVRiskAssessment, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }


  UpdateHIVRiskAssessment(payload:any){
       return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.updateHIVRiskAssessment, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

    PrimaryServiceLocationDetails(cc:string,county:string,state:string){
        return this.http.post(URLS.GOBAL_URL + URLS.ESA.PrimaryServiceLocation + cc + '&County=' + county + '&State=' + state, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

    GetMentalHealthAssessment(CC:string,AssessmentID:any){
     return this.http.post(URLS.GOBAL_URL + URLS.PHQ9_MentalAssessment.GetMentalAssessmentofPHQ9 + CC + '&FCBDD_Phq9MentalHealthAssessmentID=' + AssessmentID + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }

   GetMentalHealthAssessmentOptions(CC:string,ID:number){
     return this.http.post(URLS.GOBAL_URL + URLS.PHQ9_MentalAssessment.GetMentalAssessmentOptions + CC + '&ClientID=' + ID , this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }

     InsertMentalHealthAssessment(payload:any){
     return this.http.post(URLS.GOBAL_URL + URLS.PHQ9_MentalAssessment.insertMentalAssessmentofPHQ9, payload , this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetLevelOfCaregetRedeterminationCombination(CC:string,RedeterminationID:any){
     return this.http.post(URLS.GOBAL_URL + URLS.LevelOfCare.getRedeterminationCombination + CC + '&RedeterminationID=' + RedeterminationID + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }

   UpdateRedeterminationCombination(payload:any){
     return this.http.post(URLS.GOBAL_URL + URLS.LevelOfCare.updateRedeterminationCombination, payload, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }
    GetOptionsLevelOfCaregetRedeterminationCombination(CC:string){
     return this.http.post(URLS.GOBAL_URL + URLS.LevelOfCare.getRedeterminationCombinationOptions + CC , this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetEASTemplateDetail(companyCode: string, ) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ESA.gettemplate + companyCode,
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  DiagonsisDetails(cc:string,searchtext:string,pageindex:number){
        return this.http.post(URLS.GOBAL_URL + URLS.ESA.Get_EASDiagnosis + cc + '&SearchText=' + searchtext + '&PageIndex=' + pageindex, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

 GetEASUpdateDetail(companyCode: string,UtilityID:number ) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ESA.getupdate + companyCode + '&UtilityID='+UtilityID ,
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   insertESAapi(payload:any){
       return this.http.post(URLS.GOBAL_URL + URLS.ESA.insertESA, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
updateEASApi(payload:any){
       return this.http.post(URLS.GOBAL_URL + URLS.ESA.updateESA, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

 DemographicTemplate(CompanyCode:string){
        return this.http.post(URLS.GOBAL_URL + URLS.DEMOGRAPHICS.getTemplateDetails + CompanyCode, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  InsertDemographic(payload:any){
        return this.http.post(URLS.GOBAL_URL + URLS.DEMOGRAPHICS.insertDemographics , payload, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  InsertPreAdmissionScreeningStaging(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PRE_ADMISSION_STAGING.insertPreAdmissionStaging, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  GetPreAdmissionTemplate(companyCode: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.PRE_ADMISSION_STAGING.getPreAdmissionTemplate + companyCode, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

    USPSValidation(payload:any){
        return this.http.post(URLS.GOBAL_URL + URLS.ZIP_CODE.uspsValidation , payload, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  EAS_GetDoucumentsTypes(ComapnyCode:string,id:number){
        return this.http.post(URLS.GOBAL_URL + URLS.ESA.Get_documentList + ComapnyCode + '&EAS_DocumentConfigurationFormID=' + id, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  ZipcodeDetails(cc:string,searchtext:string,pageindex:number){
        return this.http.post(URLS.GOBAL_URL + URLS.ZIP_CODE.zipcode + cc + '&SearchText=' + searchtext + '&PageIndex=' + pageindex, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetGeneral(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getgeneral + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
    GetSignature(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getsignature + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
    GetTreatment(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.gettreatmentplan + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }


  
GetNeeds(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getneeds + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
   GetGoals(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getgoals + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
   GetObjectives(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getObjective + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
   GetInterventions(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getInterventions + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

   GetServices(udId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getservice + udId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
   GetCHLeaseViolation(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getCHLeaseViolation + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   GetSafteyplan(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getSafteyplan + clientId + '&UD_CrisisPlanFormID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetVocaQuestionnaireForm(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getVocaQuestionnaireForm + clientId + '&MMT_VocaQuestionnaireFormID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

     GetCrafft(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getcrafft + clientId + '&MMT_CrafftFormID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetDevLocusForms(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getDevLocusForms + clientId + '&dev_LocusID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   GetCalocusapi(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getCalocus + clientId + '&dev_CalocusID=' + formid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

   saveupdatesignature(savesign: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Health_Record.savesign, savesign, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }
 EAS_GetDoucuments_previews(ComapnyCode:string,UtilityID:number){
        return this.http.post(URLS.GOBAL_URL + URLS.ESA.Get_upload_preview + ComapnyCode + '&UtilityID=' + UtilityID, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
 GetHandbookPDFByPrimaryServiceLocation(ComapnyCode:string,PrimaryServiceLocation:any){
        return this.http.post(URLS.GOBAL_URL + URLS.ESA.GetHandbookPDFByPrimaryServiceLocation + ComapnyCode + '&PrimaryServiceLocation=' + PrimaryServiceLocation, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
   updateAssistiveTechnology(data: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.AssistiveTechnology.updatepackect, data, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }
   GetAssistiveTechnology(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.AssistiveTechnology.getassistivetechnology + clientId + '&FCBDD_AssistiveTechnologyAndRemoteSupportsWorksheetID=' + formid
 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetAssistiveTechnologyTemplateDetail(companycode: any,) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.AssistiveTechnology.gettemplate + companycode
        + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  // level of choice and notice to rights api
  GetlevelofFreedom(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.LevelofCare.GetLevelofCare + clientId + '&FCBDD_LevelOfCareFreedomOfChoiceSoloID=' + formid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  UpdateLevelofPayload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.LevelofCare.UpdateLevel, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
   GetLevelUDI(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.gad7api.template_details + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetLevelTemplate(CompanyCode:string){
        return this.http.post(URLS.GOBAL_URL + URLS.LevelofCare.GetTemplate + CompanyCode, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetMedicaidDueprocess(clientId: number, formid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.FCBDD_MedicaidDueProcess.GetMedicaidDueprocess + clientId + '&FCBDD_NoticeOfYourRightsToMedicaidDueProcessFormID=' + formid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  UpdateMedicaidProcess(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.FCBDD_MedicaidDueProcess.UpdateMedicaidDueprocess, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
   
  GetMedicaidTemplate(CompanyCode:string){
        return this.http.post(URLS.GOBAL_URL + URLS.FCBDD_MedicaidDueProcess.GetTemplate + CompanyCode, this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

     GetVideoAudio(clientId: number, Id: any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ConsentOfVideoandAudio.GetVideoAudiorecords + clientId + '&FCBDD_ConsentForAudioVideoRemoteSupportsFormID=' + Id + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

       GetVideoAudioTemplateOptions(CC:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ConsentOfVideoandAudio.GetTemplateOptions + CC ,this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

    UpdateVideoAudiorecord(payload:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ConsentOfVideoandAudio.UpdateVideandAudiorecords , payload ,this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
    getISP(clientId: number, recordid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ispdocument.getISP + clientId + '&ISPAnnualWaiverID=' + recordid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   UpdateSign(payload:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ispdocument.updatesign , payload ,this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   ISPprint(clientId: number, recordid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ispdocument.ISPprint + clientId + '&ISPAnnualWaiverID=' + recordid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

   SignButtonHide(payload:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ispdocument.signbuttonshowandhide , payload ,this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
   ISPDocument(clientId: number, documentid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ispdocument.ISPdocument + clientId + '&ClientDocumentID=' + documentid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetPearls(clientId: number, recordid:any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.PEARLS.GetPearlsDetails + clientId + '&PEARLSID=' + recordid

 + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetPEARLSTemplateRequest(clientId: any,CC:string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.PEARLS.GetPEARLSTemplateRequest + clientId + '&CompanyCode=' + CC,
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  InsertPEARLS(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PEARLS.InsertPEARLS, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  UpdatePEARLS(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PEARLS.UpdatePEARLS, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

  DeletePEARLS(pearlsId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.PEARLS.DeletePEARLS + pearlsId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

   GetSDOHScreeningToolOptions() {
    return this.http.post(
      URLS.GOBAL_URL + URLS.SDOHScreeningTool.getSDOHScreeningToolOptions + '?SchemaName=' + this.token() + '&ClientID=' + this.loginservice.clientid(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  GetSDOHScreeningToolDetails(sdohScreeningToolID: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.SDOHScreeningTool.getSDOHScreeningToolDetails + sdohScreeningToolID + '&SchemaName=' + this.token() + '&ClientID=' + this.loginservice.clientid(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  InsertSDOHScreeningTool(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.SDOHScreeningTool.insertSDOHScreeningTool,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  UpdateSDOHScreeningTool(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.SDOHScreeningTool.updateSDOHScreeningTool,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  GetStandardMarketingROIDetails(clientId: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.StandardMarketingROI.getDetails + '?SchemaName=' + this.token() + '&ClientID=' + clientId + '&BSL_StandardMarketingReleaseOfInformationID=0',
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  GetStandardMarketingROITemplate(clientId: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.StandardMarketingROI.getTemplate + '?SchemaName=' + this.token() + '&ClientID=' + clientId,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  InsertStandardMarketingROI(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.StandardMarketingROI.insert,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  UpdateStandardMarketingROI(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.StandardMarketingROI.update,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  DeleteStandardMarketingROI(id: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.StandardMarketingROI.delete + '?BSL_StandardMarketingReleaseOfInformationID=' + id + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  DeleteSDOHScreeningTool(sdohScreeningToolID: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.SDOHScreeningTool.deleteSDOHScreeningTool + sdohScreeningToolID + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }
  // ─── Education Report Card (dummy stubs — replace URLs when API is ready) ───

  GetEducationReportCard(clientId: number, recordId: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.EducationReportCard.GetEducationReportCardDetails + clientId +
        '&EducationReportCardID=' + recordId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  InsertEducationReportCard(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.EducationReportCard.InsertEducationReportCard,
      payload,
      this.httpOptions
    ).pipe(map((res) => res));
  }

  DeleteEducationReportCard(recordId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.EducationReportCard.DeleteEducationReportCard +
        recordId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }
   GetCrisisResponsePlan(clientId: number, crisisId: number = 0) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.CrisisResponsePlan.GetCrisisResponsePlan + clientId +
        '&CRPLA_CrisisResponsePlanID=' + crisisId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  InsertCrisisResponsePlan(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.CrisisResponsePlan.InsertCrisisResponsePlan,
      payload,
      this.httpOptions
    ).pipe(map((res) => res));
  }

  UpdateCrisisResponsePlan(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.CrisisResponsePlan.UpdateCrisisResponsePlan,
      payload,
      this.httpOptions
    ).pipe(map((res) => res));
  }

  DeleteCrisisResponsePlan(crisisId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.CrisisResponsePlan.DeleteCrisisResponsePlan + crisisId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  GetAdverseChildhoodExperiencesDetails(clientId: number, aceId: number = 0) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.AdverseChildhoodExperiences.GetAdverseChildhoodExperiencesDetails + clientId +
        '&UD_AdverseChildhoodExperiencesID=' + aceId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  GetMFHVitals(clientId: number, vitalId: number = 0) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.MFH_Vitals.GetMFHVitals + clientId +
        '&mfh_VitalsId=' + vitalId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  InsertAdverseChildhoodExperiences(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.AdverseChildhoodExperiences.InsertAdverseChildhoodExperiences,
      payload,
      this.httpOptions
    ).pipe(map((res) => res));
  }

  UpdateAdverseChildhoodExperiences(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.AdverseChildhoodExperiences.UpdateAdverseChildhoodExperiences,
      payload,
      this.httpOptions
    ).pipe(map((res) => res));
  }

  DeleteAdverseChildhoodExperiences(aceId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.AdverseChildhoodExperiences.DeleteAdverseChildhoodExperiences + aceId + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(map((res) => res));
  }

  GetNICHQVanderbiltDetails(clientId: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.NICHQVanderbilt.getDetails + '?SchemaName=' + this.token() + '&ClientID=' + clientId + '&BSL_NICHQVanderbiltAssessmentScalesID=0',
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  InsertNICHQVanderbilt(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.NICHQVanderbilt.insert,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  UpdateNICHQVanderbilt(payload: any) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.NICHQVanderbilt.update,
      payload,
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  DeleteNICHQVanderbilt(id: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.NICHQVanderbilt.delete + '?BSL_NICHQVanderbiltAssessmentScalesID=' + id + '&SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

  GetNICHQVanderbiltOptions() {
    return this.http.post(
      URLS.GOBAL_URL + URLS.NICHQVanderbilt.getOptions + '?SchemaName=' + this.token(),
      this.httpOptions
    ).pipe(
      map((res) => {
        return res;
      })
    );
  }

}
